var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('impact-goal-edit-define-impacts',{attrs:{"venture-id":_vm.ventureId}}),_vm._v(" "),(_vm.loading)?_c('ix-page-loading',{staticClass:"opacity-70 bg-none"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }